<script>
    import { Col, Label, Row } from "sveltestrap";
    import { Prefix } from "../../../utils/Constant/Constant";
    import RangeSlider from 'svelte-range-slider-pips';
</script>
<Row class="form-group">
    <Label class="col-md-2 sm-left-text">{Prefix}</Label>
    <Col md="10">
      <RangeSlider pips prefix="$" first="label" last="label" value={100} float />
    </Col>
</Row>